import { createContext, useContext, useState, useEffect } from 'react';

// Translations for all supported languages
const translations = {
  en: {
    // App
    appName: 'Skybot',
    tagline: 'AI Sky Anomaly Detection',
    
    // Navigation & Modes
    liveCamera: 'Live Camera',
    upload: 'Upload',
    uploadImage: 'Upload Image',
    video: 'Video',
    videoAnalysis: 'Video Analysis',
    gallery: 'Gallery',
    settings: 'Settings',
    
    // Camera Controls
    photo: 'PHOTO',
    videoMode: 'VIDEO',
    capture: 'Capture',
    startRecording: 'Start Recording',
    stopRecording: 'Stop Recording',
    recording: 'Recording',
    
    // Filters
    filters: 'Filters',
    freeFilters: 'Free Filters',
    premiumFilters: 'Premium Filters',
    solar: 'Solar',
    night: 'Night',
    clarity: 'Clarity',
    stars: 'Stars',
    anomaly: 'Anomaly',
    nightVision: 'Vision',
    infrared: 'Infrared',
    thermal: 'Thermal',
    motion: 'Motion',
    track: 'Track',
    
    // Zoom
    zoom: 'Zoom',
    ultraZoom: 'Ultra Zoom',
    
    // Analysis
    analyze: 'Analyze',
    analyzing: 'Analyzing...',
    aiAnalysis: 'AI Analysis',
    detectedAnomalies: 'Detected Anomalies',
    confidence: 'Confidence',
    noAnomaliesDetected: 'No anomalies detected',
    
    // Premium
    premium: 'Premium',
    upgrade: 'Upgrade',
    unlockPremium: 'Unlock Premium',
    ownerMode: 'Owner Mode',
    allFeaturesUnlocked: 'All features unlocked',
    
    // Actions
    save: 'Save',
    share: 'Share',
    download: 'Download',
    reset: 'Reset',
    back: 'Back',
    home: 'Home',
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'Confirm',
    
    // Fullscreen
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit Fullscreen',
    
    // Theme
    changeTheme: 'Change Theme',
    themes: 'Themes',
    
    // Language
    language: 'Language',
    
    // Messages
    cameraAccessDenied: 'Could not access camera. Please grant permission or use upload mode.',
    captureSuccess: 'Capture successful',
    uploadSuccess: 'Upload successful',
    analysisComplete: 'Analysis complete',
    
    // Landing Page
    startScanning: 'Start Scanning',
    installApp: 'Install App',
    viewGallery: 'View Gallery',
    aiEngine: 'AI ENGINE',
    resolution: 'RESOLUTION',
  },
  
  es: {
    appName: 'Skybot',
    tagline: 'Detección de Anomalías del Cielo con IA',
    liveCamera: 'Cámara en Vivo',
    upload: 'Subir',
    uploadImage: 'Subir Imagen',
    video: 'Video',
    videoAnalysis: 'Análisis de Video',
    gallery: 'Galería',
    settings: 'Configuración',
    photo: 'FOTO',
    videoMode: 'VIDEO',
    capture: 'Capturar',
    startRecording: 'Iniciar Grabación',
    stopRecording: 'Detener Grabación',
    recording: 'Grabando',
    filters: 'Filtros',
    freeFilters: 'Filtros Gratis',
    premiumFilters: 'Filtros Premium',
    solar: 'Solar',
    night: 'Noche',
    clarity: 'Claridad',
    stars: 'Estrellas',
    anomaly: 'Anomalía',
    nightVision: 'Visión',
    infrared: 'Infrarrojo',
    thermal: 'Térmico',
    motion: 'Movimiento',
    track: 'Rastrear',
    zoom: 'Zoom',
    ultraZoom: 'Ultra Zoom',
    analyze: 'Analizar',
    analyzing: 'Analizando...',
    aiAnalysis: 'Análisis IA',
    detectedAnomalies: 'Anomalías Detectadas',
    confidence: 'Confianza',
    noAnomaliesDetected: 'No se detectaron anomalías',
    premium: 'Premium',
    upgrade: 'Actualizar',
    unlockPremium: 'Desbloquear Premium',
    ownerMode: 'Modo Propietario',
    allFeaturesUnlocked: 'Todas las funciones desbloqueadas',
    save: 'Guardar',
    share: 'Compartir',
    download: 'Descargar',
    reset: 'Reiniciar',
    back: 'Atrás',
    home: 'Inicio',
    close: 'Cerrar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    fullscreen: 'Pantalla Completa',
    exitFullscreen: 'Salir de Pantalla Completa',
    changeTheme: 'Cambiar Tema',
    themes: 'Temas',
    language: 'Idioma',
    cameraAccessDenied: 'No se pudo acceder a la cámara. Por favor, otorgue permiso o use el modo de carga.',
    captureSuccess: 'Captura exitosa',
    uploadSuccess: 'Carga exitosa',
    analysisComplete: 'Análisis completo',
    startScanning: 'Iniciar Escaneo',
    installApp: 'Instalar App',
    viewGallery: 'Ver Galería',
    aiEngine: 'MOTOR IA',
    resolution: 'RESOLUCIÓN',
  },
  
  fr: {
    appName: 'Skybot',
    tagline: 'Détection d\'Anomalies du Ciel par IA',
    liveCamera: 'Caméra en Direct',
    upload: 'Télécharger',
    uploadImage: 'Télécharger Image',
    video: 'Vidéo',
    videoAnalysis: 'Analyse Vidéo',
    gallery: 'Galerie',
    settings: 'Paramètres',
    photo: 'PHOTO',
    videoMode: 'VIDÉO',
    capture: 'Capturer',
    startRecording: 'Démarrer l\'Enregistrement',
    stopRecording: 'Arrêter l\'Enregistrement',
    recording: 'Enregistrement',
    filters: 'Filtres',
    freeFilters: 'Filtres Gratuits',
    premiumFilters: 'Filtres Premium',
    solar: 'Solaire',
    night: 'Nuit',
    clarity: 'Clarté',
    stars: 'Étoiles',
    anomaly: 'Anomalie',
    nightVision: 'Vision',
    infrared: 'Infrarouge',
    thermal: 'Thermique',
    motion: 'Mouvement',
    track: 'Suivre',
    zoom: 'Zoom',
    ultraZoom: 'Ultra Zoom',
    analyze: 'Analyser',
    analyzing: 'Analyse en cours...',
    aiAnalysis: 'Analyse IA',
    detectedAnomalies: 'Anomalies Détectées',
    confidence: 'Confiance',
    noAnomaliesDetected: 'Aucune anomalie détectée',
    premium: 'Premium',
    upgrade: 'Améliorer',
    unlockPremium: 'Débloquer Premium',
    ownerMode: 'Mode Propriétaire',
    allFeaturesUnlocked: 'Toutes les fonctionnalités débloquées',
    save: 'Sauvegarder',
    share: 'Partager',
    download: 'Télécharger',
    reset: 'Réinitialiser',
    back: 'Retour',
    home: 'Accueil',
    close: 'Fermer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    fullscreen: 'Plein Écran',
    exitFullscreen: 'Quitter le Plein Écran',
    changeTheme: 'Changer le Thème',
    themes: 'Thèmes',
    language: 'Langue',
    cameraAccessDenied: 'Impossible d\'accéder à la caméra. Veuillez accorder la permission ou utiliser le mode téléchargement.',
    captureSuccess: 'Capture réussie',
    uploadSuccess: 'Téléchargement réussi',
    analysisComplete: 'Analyse terminée',
    startScanning: 'Démarrer le Scan',
    installApp: 'Installer l\'App',
    viewGallery: 'Voir la Galerie',
    aiEngine: 'MOTEUR IA',
    resolution: 'RÉSOLUTION',
  },
  
  de: {
    appName: 'Skybot',
    tagline: 'KI-gestützte Himmelsanomalie-Erkennung',
    liveCamera: 'Live-Kamera',
    upload: 'Hochladen',
    uploadImage: 'Bild Hochladen',
    video: 'Video',
    videoAnalysis: 'Video-Analyse',
    gallery: 'Galerie',
    settings: 'Einstellungen',
    photo: 'FOTO',
    videoMode: 'VIDEO',
    capture: 'Aufnehmen',
    startRecording: 'Aufnahme Starten',
    stopRecording: 'Aufnahme Stoppen',
    recording: 'Aufnahme',
    filters: 'Filter',
    freeFilters: 'Kostenlose Filter',
    premiumFilters: 'Premium-Filter',
    solar: 'Solar',
    night: 'Nacht',
    clarity: 'Klarheit',
    stars: 'Sterne',
    anomaly: 'Anomalie',
    nightVision: 'Sicht',
    infrared: 'Infrarot',
    thermal: 'Thermisch',
    motion: 'Bewegung',
    track: 'Verfolgen',
    zoom: 'Zoom',
    ultraZoom: 'Ultra-Zoom',
    analyze: 'Analysieren',
    analyzing: 'Analysiere...',
    aiAnalysis: 'KI-Analyse',
    detectedAnomalies: 'Erkannte Anomalien',
    confidence: 'Vertrauen',
    noAnomaliesDetected: 'Keine Anomalien erkannt',
    premium: 'Premium',
    upgrade: 'Upgraden',
    unlockPremium: 'Premium Freischalten',
    ownerMode: 'Besitzer-Modus',
    allFeaturesUnlocked: 'Alle Funktionen freigeschaltet',
    save: 'Speichern',
    share: 'Teilen',
    download: 'Herunterladen',
    reset: 'Zurücksetzen',
    back: 'Zurück',
    home: 'Startseite',
    close: 'Schließen',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    fullscreen: 'Vollbild',
    exitFullscreen: 'Vollbild Beenden',
    changeTheme: 'Theme Ändern',
    themes: 'Themes',
    language: 'Sprache',
    cameraAccessDenied: 'Kamerazugriff nicht möglich. Bitte Berechtigung erteilen oder Hochladen-Modus verwenden.',
    captureSuccess: 'Aufnahme erfolgreich',
    uploadSuccess: 'Hochladen erfolgreich',
    analysisComplete: 'Analyse abgeschlossen',
    startScanning: 'Scan Starten',
    installApp: 'App Installieren',
    viewGallery: 'Galerie Ansehen',
    aiEngine: 'KI-ENGINE',
    resolution: 'AUFLÖSUNG',
  },
  
  zh: {
    appName: 'Skybot',
    tagline: 'AI天空异常检测',
    liveCamera: '实时摄像',
    upload: '上传',
    uploadImage: '上传图片',
    video: '视频',
    videoAnalysis: '视频分析',
    gallery: '图库',
    settings: '设置',
    photo: '拍照',
    videoMode: '录像',
    capture: '拍摄',
    startRecording: '开始录制',
    stopRecording: '停止录制',
    recording: '录制中',
    filters: '滤镜',
    freeFilters: '免费滤镜',
    premiumFilters: '高级滤镜',
    solar: '太阳',
    night: '夜晚',
    clarity: '清晰',
    stars: '星星',
    anomaly: '异常',
    nightVision: '夜视',
    infrared: '红外',
    thermal: '热成像',
    motion: '动态',
    track: '追踪',
    zoom: '缩放',
    ultraZoom: '超级缩放',
    analyze: '分析',
    analyzing: '分析中...',
    aiAnalysis: 'AI分析',
    detectedAnomalies: '检测到的异常',
    confidence: '置信度',
    noAnomaliesDetected: '未检测到异常',
    premium: '高级版',
    upgrade: '升级',
    unlockPremium: '解锁高级版',
    ownerMode: '所有者模式',
    allFeaturesUnlocked: '所有功能已解锁',
    save: '保存',
    share: '分享',
    download: '下载',
    reset: '重置',
    back: '返回',
    home: '首页',
    close: '关闭',
    cancel: '取消',
    confirm: '确认',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
    changeTheme: '更换主题',
    themes: '主题',
    language: '语言',
    cameraAccessDenied: '无法访问摄像头。请授权或使用上传模式。',
    captureSuccess: '拍摄成功',
    uploadSuccess: '上传成功',
    analysisComplete: '分析完成',
    startScanning: '开始扫描',
    installApp: '安装应用',
    viewGallery: '查看图库',
    aiEngine: 'AI引擎',
    resolution: '分辨率',
  },
  
  ja: {
    appName: 'Skybot',
    tagline: 'AI空異常検出',
    liveCamera: 'ライブカメラ',
    upload: 'アップロード',
    uploadImage: '画像をアップロード',
    video: 'ビデオ',
    videoAnalysis: 'ビデオ分析',
    gallery: 'ギャラリー',
    settings: '設定',
    photo: '写真',
    videoMode: 'ビデオ',
    capture: '撮影',
    startRecording: '録画開始',
    stopRecording: '録画停止',
    recording: '録画中',
    filters: 'フィルター',
    freeFilters: '無料フィルター',
    premiumFilters: 'プレミアムフィルター',
    solar: 'ソーラー',
    night: 'ナイト',
    clarity: 'クラリティ',
    stars: 'スター',
    anomaly: '異常',
    nightVision: 'ビジョン',
    infrared: '赤外線',
    thermal: 'サーマル',
    motion: 'モーション',
    track: 'トラック',
    zoom: 'ズーム',
    ultraZoom: 'ウルトラズーム',
    analyze: '分析',
    analyzing: '分析中...',
    aiAnalysis: 'AI分析',
    detectedAnomalies: '検出された異常',
    confidence: '信頼度',
    noAnomaliesDetected: '異常は検出されませんでした',
    premium: 'プレミアム',
    upgrade: 'アップグレード',
    unlockPremium: 'プレミアムを解除',
    ownerMode: 'オーナーモード',
    allFeaturesUnlocked: '全機能が解除されました',
    save: '保存',
    share: '共有',
    download: 'ダウンロード',
    reset: 'リセット',
    back: '戻る',
    home: 'ホーム',
    close: '閉じる',
    cancel: 'キャンセル',
    confirm: '確認',
    fullscreen: 'フルスクリーン',
    exitFullscreen: 'フルスクリーン終了',
    changeTheme: 'テーマ変更',
    themes: 'テーマ',
    language: '言語',
    cameraAccessDenied: 'カメラにアクセスできません。許可を与えるか、アップロードモードを使用してください。',
    captureSuccess: '撮影成功',
    uploadSuccess: 'アップロード成功',
    analysisComplete: '分析完了',
    startScanning: 'スキャン開始',
    installApp: 'アプリをインストール',
    viewGallery: 'ギャラリーを見る',
    aiEngine: 'AIエンジン',
    resolution: '解像度',
  },
  
  pt: {
    appName: 'Skybot',
    tagline: 'Detecção de Anomalias do Céu com IA',
    liveCamera: 'Câmera ao Vivo',
    upload: 'Carregar',
    uploadImage: 'Carregar Imagem',
    video: 'Vídeo',
    videoAnalysis: 'Análise de Vídeo',
    gallery: 'Galeria',
    settings: 'Configurações',
    photo: 'FOTO',
    videoMode: 'VÍDEO',
    capture: 'Capturar',
    startRecording: 'Iniciar Gravação',
    stopRecording: 'Parar Gravação',
    recording: 'Gravando',
    filters: 'Filtros',
    freeFilters: 'Filtros Grátis',
    premiumFilters: 'Filtros Premium',
    solar: 'Solar',
    night: 'Noite',
    clarity: 'Clareza',
    stars: 'Estrelas',
    anomaly: 'Anomalia',
    nightVision: 'Visão',
    infrared: 'Infravermelho',
    thermal: 'Térmico',
    motion: 'Movimento',
    track: 'Rastrear',
    zoom: 'Zoom',
    ultraZoom: 'Ultra Zoom',
    analyze: 'Analisar',
    analyzing: 'Analisando...',
    aiAnalysis: 'Análise IA',
    detectedAnomalies: 'Anomalias Detectadas',
    confidence: 'Confiança',
    noAnomaliesDetected: 'Nenhuma anomalia detectada',
    premium: 'Premium',
    upgrade: 'Atualizar',
    unlockPremium: 'Desbloquear Premium',
    ownerMode: 'Modo Proprietário',
    allFeaturesUnlocked: 'Todos os recursos desbloqueados',
    save: 'Salvar',
    share: 'Compartilhar',
    download: 'Baixar',
    reset: 'Reiniciar',
    back: 'Voltar',
    home: 'Início',
    close: 'Fechar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    fullscreen: 'Tela Cheia',
    exitFullscreen: 'Sair da Tela Cheia',
    changeTheme: 'Mudar Tema',
    themes: 'Temas',
    language: 'Idioma',
    cameraAccessDenied: 'Não foi possível acessar a câmera. Por favor, conceda permissão ou use o modo de upload.',
    captureSuccess: 'Captura bem-sucedida',
    uploadSuccess: 'Upload bem-sucedido',
    analysisComplete: 'Análise completa',
    startScanning: 'Iniciar Escaneamento',
    installApp: 'Instalar App',
    viewGallery: 'Ver Galeria',
    aiEngine: 'MOTOR IA',
    resolution: 'RESOLUÇÃO',
  },
  
  ar: {
    appName: 'Skybot',
    tagline: 'كشف الشذوذ في السماء بالذكاء الاصطناعي',
    liveCamera: 'كاميرا مباشرة',
    upload: 'رفع',
    uploadImage: 'رفع صورة',
    video: 'فيديو',
    videoAnalysis: 'تحليل الفيديو',
    gallery: 'المعرض',
    settings: 'الإعدادات',
    photo: 'صورة',
    videoMode: 'فيديو',
    capture: 'التقاط',
    startRecording: 'بدء التسجيل',
    stopRecording: 'إيقاف التسجيل',
    recording: 'جاري التسجيل',
    filters: 'الفلاتر',
    freeFilters: 'فلاتر مجانية',
    premiumFilters: 'فلاتر مميزة',
    solar: 'شمسي',
    night: 'ليلي',
    clarity: 'وضوح',
    stars: 'نجوم',
    anomaly: 'شذوذ',
    nightVision: 'رؤية',
    infrared: 'أشعة تحت حمراء',
    thermal: 'حراري',
    motion: 'حركة',
    track: 'تتبع',
    zoom: 'تكبير',
    ultraZoom: 'تكبير فائق',
    analyze: 'تحليل',
    analyzing: 'جاري التحليل...',
    aiAnalysis: 'تحليل الذكاء الاصطناعي',
    detectedAnomalies: 'الشذوذ المكتشف',
    confidence: 'الثقة',
    noAnomaliesDetected: 'لم يتم اكتشاف أي شذوذ',
    premium: 'مميز',
    upgrade: 'ترقية',
    unlockPremium: 'فتح المميز',
    ownerMode: 'وضع المالك',
    allFeaturesUnlocked: 'تم فتح جميع الميزات',
    save: 'حفظ',
    share: 'مشاركة',
    download: 'تحميل',
    reset: 'إعادة تعيين',
    back: 'رجوع',
    home: 'الرئيسية',
    close: 'إغلاق',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    fullscreen: 'ملء الشاشة',
    exitFullscreen: 'الخروج من ملء الشاشة',
    changeTheme: 'تغيير السمة',
    themes: 'السمات',
    language: 'اللغة',
    cameraAccessDenied: 'تعذر الوصول إلى الكاميرا. يرجى منح الإذن أو استخدام وضع الرفع.',
    captureSuccess: 'تم الالتقاط بنجاح',
    uploadSuccess: 'تم الرفع بنجاح',
    analysisComplete: 'اكتمل التحليل',
    startScanning: 'بدء المسح',
    installApp: 'تثبيت التطبيق',
    viewGallery: 'عرض المعرض',
    aiEngine: 'محرك الذكاء',
    resolution: 'الدقة',
  },
  
  ru: {
    appName: 'Skybot',
    tagline: 'ИИ-обнаружение небесных аномалий',
    liveCamera: 'Живая Камера',
    upload: 'Загрузить',
    uploadImage: 'Загрузить Изображение',
    video: 'Видео',
    videoAnalysis: 'Анализ Видео',
    gallery: 'Галерея',
    settings: 'Настройки',
    photo: 'ФОТО',
    videoMode: 'ВИДЕО',
    capture: 'Снять',
    startRecording: 'Начать Запись',
    stopRecording: 'Остановить Запись',
    recording: 'Запись',
    filters: 'Фильтры',
    freeFilters: 'Бесплатные Фильтры',
    premiumFilters: 'Премиум Фильтры',
    solar: 'Солнце',
    night: 'Ночь',
    clarity: 'Четкость',
    stars: 'Звезды',
    anomaly: 'Аномалия',
    nightVision: 'Зрение',
    infrared: 'Инфракрасный',
    thermal: 'Тепловой',
    motion: 'Движение',
    track: 'Слежение',
    zoom: 'Зум',
    ultraZoom: 'Ультра Зум',
    analyze: 'Анализировать',
    analyzing: 'Анализ...',
    aiAnalysis: 'ИИ Анализ',
    detectedAnomalies: 'Обнаруженные Аномалии',
    confidence: 'Уверенность',
    noAnomaliesDetected: 'Аномалии не обнаружены',
    premium: 'Премиум',
    upgrade: 'Обновить',
    unlockPremium: 'Разблокировать Премиум',
    ownerMode: 'Режим Владельца',
    allFeaturesUnlocked: 'Все функции разблокированы',
    save: 'Сохранить',
    share: 'Поделиться',
    download: 'Скачать',
    reset: 'Сброс',
    back: 'Назад',
    home: 'Главная',
    close: 'Закрыть',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    fullscreen: 'Полный Экран',
    exitFullscreen: 'Выйти из Полного Экрана',
    changeTheme: 'Сменить Тему',
    themes: 'Темы',
    language: 'Язык',
    cameraAccessDenied: 'Не удалось получить доступ к камере. Предоставьте разрешение или используйте режим загрузки.',
    captureSuccess: 'Снимок сделан',
    uploadSuccess: 'Загрузка успешна',
    analysisComplete: 'Анализ завершен',
    startScanning: 'Начать Сканирование',
    installApp: 'Установить Приложение',
    viewGallery: 'Смотреть Галерею',
    aiEngine: 'ИИ ДВИЖОК',
    resolution: 'РАЗРЕШЕНИЕ',
  },
  
  ko: {
    appName: 'Skybot',
    tagline: 'AI 하늘 이상 감지',
    liveCamera: '라이브 카메라',
    upload: '업로드',
    uploadImage: '이미지 업로드',
    video: '비디오',
    videoAnalysis: '비디오 분석',
    gallery: '갤러리',
    settings: '설정',
    photo: '사진',
    videoMode: '비디오',
    capture: '촬영',
    startRecording: '녹화 시작',
    stopRecording: '녹화 중지',
    recording: '녹화 중',
    filters: '필터',
    freeFilters: '무료 필터',
    premiumFilters: '프리미엄 필터',
    solar: '태양',
    night: '야간',
    clarity: '선명도',
    stars: '별',
    anomaly: '이상',
    nightVision: '야시',
    infrared: '적외선',
    thermal: '열화상',
    motion: '모션',
    track: '추적',
    zoom: '줌',
    ultraZoom: '울트라 줌',
    analyze: '분석',
    analyzing: '분석 중...',
    aiAnalysis: 'AI 분석',
    detectedAnomalies: '감지된 이상',
    confidence: '신뢰도',
    noAnomaliesDetected: '이상이 감지되지 않음',
    premium: '프리미엄',
    upgrade: '업그레이드',
    unlockPremium: '프리미엄 잠금 해제',
    ownerMode: '소유자 모드',
    allFeaturesUnlocked: '모든 기능 잠금 해제됨',
    save: '저장',
    share: '공유',
    download: '다운로드',
    reset: '재설정',
    back: '뒤로',
    home: '홈',
    close: '닫기',
    cancel: '취소',
    confirm: '확인',
    fullscreen: '전체 화면',
    exitFullscreen: '전체 화면 종료',
    changeTheme: '테마 변경',
    themes: '테마',
    language: '언어',
    cameraAccessDenied: '카메라에 액세스할 수 없습니다. 권한을 부여하거나 업로드 모드를 사용하세요.',
    captureSuccess: '촬영 성공',
    uploadSuccess: '업로드 성공',
    analysisComplete: '분석 완료',
    startScanning: '스캔 시작',
    installApp: '앱 설치',
    viewGallery: '갤러리 보기',
    aiEngine: 'AI 엔진',
    resolution: '해상도',
  },
};

// Language names for display
export const languageNames = {
  en: { name: 'English', flag: '🇺🇸' },
  es: { name: 'Español', flag: '🇪🇸' },
  fr: { name: 'Français', flag: '🇫🇷' },
  de: { name: 'Deutsch', flag: '🇩🇪' },
  zh: { name: '中文', flag: '🇨🇳' },
  ja: { name: '日本語', flag: '🇯🇵' },
  pt: { name: 'Português', flag: '🇧🇷' },
  ar: { name: 'العربية', flag: '🇸🇦' },
  ru: { name: 'Русский', flag: '🇷🇺' },
  ko: { name: '한국어', flag: '🇰🇷' },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Detect browser language or use stored preference
  const getInitialLanguage = () => {
    const stored = localStorage.getItem('skybot_language');
    if (stored && translations[stored]) return stored;
    
    const browserLang = navigator.language.split('-')[0];
    if (translations[browserLang]) return browserLang;
    
    return 'en';
  };

  const [language, setLanguage] = useState(getInitialLanguage);

  // Save language preference
  useEffect(() => {
    localStorage.setItem('skybot_language', language);
    // Set document direction for RTL languages
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  // Get translation function
  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  const value = {
    language,
    setLanguage,
    t,
    languages: Object.keys(translations),
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
